@if (gateComponents()) {
  <p-table
    #componentsTable
    [columns]="columns"
    [value]="gateComponents() ?? []"
    [tableStyle]="{ 'min-width': '50rem' }"
    class="p-3 transparent tableHeaderAlignTop"
    [scrollable]="true"
  >
    <ng-template #caption>
      <div class="flex justify-content-end align-items-center gap-2">
        <app-svg-icon
          id="createComponentButton"
          *appHasPermission="{
            permissions: [permissions.allPermissions.ASSET_COMPONENT_CREATE],
          }"
          class="pointer"
          iconName="plus"
          iconColor="primary"
          (click)="onCreateClick()"
        >
        </app-svg-icon>
      </div>
    </ng-template>
    <ng-template #header let-columns>
      <tr>
        @for (col of columns; track col) {
          <th>
            {{ col.header | translate }}
          </th>
        }
        <th style="width: 10%"></th>
      </tr>
    </ng-template>

    <ng-template #body let-rowData let-columns="columns">
      <tr>
        @for (col of columns; track col) {
          <td>
            {{ rowData[col.field] }}
          </td>
        }
        <td class="flex gap-4">
          <app-svg-icon
            [id]="'editComponentButton' + rowData['id'].toString()"
            *appHasPermission="{
              permissions: [permissions.allPermissions.ASSET_COMPONENT_UPDATE],
            }"
            class="pointer"
            iconName="edit"
            iconColor="primary"
            (click)="onEditClick(rowData)"
          ></app-svg-icon>

          <app-svg-icon
            [id]="'deleteComponentButton' + rowData['id'].toString()"
            *appHasPermission="{
              permissions: [permissions.allPermissions.ASSET_COMPONENT_DELETE],
            }"
            class="pointer"
            iconName="trash"
            iconColor="primary"
            (click)="onDeleteClick($event, rowData)"
          ></app-svg-icon>
        </td>
      </tr>
    </ng-template>
  </p-table>
}
